import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { EventCategory }                                from 'Domain/Models';

export const getEventCategories = (state: TRootState, filter: null | IFilterProps<EventCategory> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'name', order: 'ASC' } }) as IFilterProps<EventCategory>;
  }

  return filterObjectStore(state.eventCategory.entries, filter);
};
